export class VnaPortalSelected {
    pkPortal: number;
    portal: string;
    private isFirst: boolean;

    constructor(pkPortal: number, portal: string, isFirst: boolean) {
        this.pkPortal = pkPortal;
        this.portal = portal;
        this.isFirst = isFirst;
    }

    getPkPortal(): number {
        return this.pkPortal;
    }

    getPortal(): string {
        return this.portal;
    }

    isTheFirst(): boolean {
        return this.isFirst;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/core/data/messaging/VnaPortalSelected.ts